import { render, staticRenderFns } from "./FeaturedPropertySidebar.vue?vue&type=template&id=bab2089c&scoped=true&"
import script from "./FeaturedPropertySidebar.vue?vue&type=script&lang=js&"
export * from "./FeaturedPropertySidebar.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPropertySidebar.vue?vue&type=style&index=0&id=bab2089c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab2089c",
  null
  
)

export default component.exports